import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const CaseStudyCard = ({ study }) => {
    const { slug, published, title, client, industry, cardDescription, technologies } = study;

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            background: published ? 'var(--color-extra04)' : 'var(--color-blackest)',
            borderRadius: 'var(--radius)',
            border: published
                ? '1px solid rgba(255, 90, 9, 0.35)'
                : '1px solid var(--color-border)',
            borderTop: published ? '3px solid var(--color-primary)' : undefined,
            padding: '28px 28px 24px',
            boxSizing: 'border-box',
            overflow: 'hidden',
            transition: 'transform 0.25s, box-shadow 0.25s',
        }}>

            {/* Header row: industry label + coming-soon badge */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <span style={{
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '0.12em',
                    textTransform: 'uppercase',
                    color: 'var(--color-primary)',
                    lineHeight: 1,
                    flex: 1,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    marginRight: '8px',
                }}>
                    {industry}
                </span>
                {!published && (
                    <span style={{
                        fontSize: '10px',
                        fontWeight: 600,
                        letterSpacing: '0.1em',
                        textTransform: 'uppercase',
                        color: 'rgba(255,255,255,0.3)',
                        background: 'rgba(255,255,255,0.05)',
                        border: '1px solid rgba(255,255,255,0.1)',
                        borderRadius: '20px',
                        padding: '3px 10px',
                        whiteSpace: 'nowrap',
                    }}>
                        Coming soon
                    </span>
                )}
            </div>

            {/* Title */}
            <h3 style={{
                fontSize: '19px',
                fontWeight: 700,
                lineHeight: 1.3,
                color: published ? 'var(--color-heading)' : 'rgba(255,255,255,0.5)',
                margin: '0 0 8px 0',
            }}>
                {published
                    ? <Link to={`/case-studies/${slug}`} style={{ color: 'inherit', textDecoration: 'none' }}>{title}</Link>
                    : title
                }
            </h3>

            {/* Client */}
            {client && (
                <p style={{
                    fontSize: '13px',
                    color: 'rgba(255,255,255,0.4)',
                    margin: '0 0 16px 0',
                    fontWeight: 500,
                }}>
                    {client}
                </p>
            )}

            {/* Description — flex-grow fills available space so all cards in a row align their bottoms */}
            <p style={{
                fontSize: '15px',
                lineHeight: 1.7,
                color: published ? 'var(--color-body)' : 'rgba(255,255,255,0.25)',
                margin: '0 0 20px 0',
                flexGrow: 1,
            }}>
                {cardDescription}
            </p>

            {/* Tech chips */}
            {technologies && technologies.length > 0 && published && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '22px' }}>
                    {technologies.slice(0, 4).map((tech, i) => (
                        <span key={i} style={{
                            fontSize: '11px',
                            padding: '4px 10px',
                            borderRadius: '4px',
                            background: 'rgba(255, 90, 9, 0.08)',
                            border: '1px solid rgba(255, 90, 9, 0.2)',
                            color: 'rgba(255,255,255,0.65)',
                            whiteSpace: 'nowrap',
                            fontWeight: 500,
                        }}>
                            {tech}
                        </span>
                    ))}
                    {technologies.length > 4 && (
                        <span style={{
                            fontSize: '11px',
                            color: 'rgba(255,255,255,0.3)',
                            alignSelf: 'center',
                            padding: '4px 6px',
                        }}>
                            +{technologies.length - 4} more
                        </span>
                    )}
                </div>
            )}

            {/* Divider */}
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.07)', paddingTop: '18px' }}>
                {published ? (
                    <Link
                        to={`/case-studies/${slug}`}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '7px',
                            fontSize: '14px',
                            fontWeight: 600,
                            color: 'var(--color-primary)',
                            textDecoration: 'none',
                        }}
                    >
                        Read case study <FiArrowRight size={14} />
                    </Link>
                ) : (
                    <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.18)', fontStyle: 'italic' }}>
                        Details coming soon
                    </span>
                )}
            </div>
        </div>
    );
};

export default CaseStudyCard;
